module.exports = __webpack_public_path__ + "c099b51831fd7b0e17070124503bfbb4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PL.svg
// module id = iMYx
// module chunks = 0